/* eslint-disable react/no-multi-comp */
import React from 'react';
import { Link } from '@scentregroup/shared/link';
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import classNames from 'classnames';
import { storeIsOpen, storeIsOpeningSoon, isAfterDate } from '../../helpers/store-helper';
import ExternalLink from '../external-link';
import Image from '../image';
import { parseStoreHours } from '../../helpers/parse-opening-hours/parse-store-hours';
import UtilityBoxOpeningHours from '../utility-box-opening-hours';
import UtilityBox from '../utility-box-v2';
import UtilityBoxItem from '../utility-box-item-v2';
import style from './index.module.scss';
import { Box } from '@hub/box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StoreStatus = props => {
  const {
    status
  } = props;
  if (status && !storeIsOpen(status)) {
    return /*#__PURE__*/_jsx(UtilityBoxItem, {
      icon: "hours",
      "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem",
      children: /*#__PURE__*/_jsx(Paragraph, {
        type: "medium",
        "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem_Paragraph",
        children: status
      })
    });
  }
  return null;
};
function hasHours(openHours) {
  return Boolean(openHours.storeTradingSchedule && openHours.centreTradingSchedule && openHours.timeZone);
}
const StoreOpeningHours = props => {
  const {
    status,
    openHours
  } = props;
  // If a store has a status, it must be open
  if (hasHours(openHours) && status && storeIsOpen(status)) {
    const parsedHours = parseStoreHours(openHours.storeTradingSchedule, openHours.centreTradingSchedule, openHours.timeZone);
    return /*#__PURE__*/_jsx(UtilityBoxOpeningHours, {
      openingHours: parsedHours,
      "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxOpeningHours"
    });
  }
  return null;
};
const StoreLocation = props => {
  const {
    status,
    location,
    nearestLocation,
    locationLink,
    openAt
  } = props;
  const displayLink = status && (storeIsOpen(status) || storeIsOpeningSoon(status) && isAfterDate(openAt)) && (location || nearestLocation || locationLink);
  if (displayLink) {
    return /*#__PURE__*/_jsxs(UtilityBoxItem, {
      icon: "location-drop-pin",
      role: "heading",
      "aria-label": "Store Location",
      "aria-level": "4",
      "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem",
      children: [location && /*#__PURE__*/_jsx(Paragraph, {
        type: "medium",
        className: style.location,
        "data-id": "retailer-utility-box-v2_index_StoreStatus_Paragraph",
        children: location
      }), nearestLocation && /*#__PURE__*/_jsx(Paragraph, {
        type: "medium",
        "data-id": "retailer-utility-box-v2_index_StoreStatus_Paragraph_5",
        children: nearestLocation
      }), locationLink && /*#__PURE__*/_jsx(Link, {
        className: style.mapLink,
        to: locationLink,
        "data-id": "retailer-utility-box-v2_index_StoreStatus_Link",
        children: "See on map"
      })]
    });
  }
  return null;
};
const WebsiteLink = props => {
  const {
    websiteAddress,
    link,
    linkText
  } = props;
  if (websiteAddress) {
    return /*#__PURE__*/_jsx(ExternalLink, {
      url: websiteAddress,
      "data-id": "retailer-utility-box-v2_index_StoreStatus_ExternalLink",
      children: websiteAddress
    });
  }
  if (Boolean(link) && linkText) {
    return /*#__PURE__*/_jsx(ExternalLink, {
      url: link,
      "data-id": "retailer-utility-box-v2_index_StoreStatus_ExternalLink_8",
      children: linkText
    });
  }
  return null;
};
const RetailerUtilityBox = _ref => {
  let {
    className,
    heading,
    status,
    openHours,
    phoneNumber,
    emailAddress,
    location,
    link,
    linkText,
    websiteAddress,
    locationLink,
    nearestLocation,
    parkingLocation,
    storeImage,
    storeLink,
    openAt
  } = _ref;
  const hasWebsite = Boolean(link) && linkText || websiteAddress;
  return /*#__PURE__*/_jsxs(UtilityBox, {
    className: classNames(style.UtilityBox, className),
    "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBox",
    children: [/*#__PURE__*/_jsxs("div", {
      className: style.utilityInfoWrapper,
      "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBox_div",
      children: [/*#__PURE__*/_jsx(Heading, {
        type: "small",
        className: style.heading,
        "data-id": "retailer-utility-box-v2_index_StoreStatus_div_Heading",
        children: storeLink ? /*#__PURE__*/_jsxs(Link, {
          to: storeLink,
          "data-id": "retailer-utility-box-v2_index_StoreStatus_Link",
          children: [" ", heading, " "]
        }) : heading
      }), /*#__PURE__*/_jsx(StoreStatus, {
        status: status || undefined,
        "data-id": "retailer-utility-box-v2_index_div_StoreStatus"
      }), openHours && /*#__PURE__*/_jsx(Box, {
        sx: {
          paddingBottom: 'spacing-md'
        },
        "data-id": "retailer-utility-box-v2_index_StoreStatus_Box",
        children: /*#__PURE__*/_jsx(StoreOpeningHours, {
          status: status || undefined,
          openHours: openHours,
          "data-id": "retailer-utility-box-v2_index_StoreStatus_Box_StoreOpeningHours"
        })
      }), phoneNumber && /*#__PURE__*/_jsx(UtilityBoxItem, {
        icon: "phone",
        role: "heading",
        "aria-label": "Phone Number",
        "aria-level": "4",
        "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem",
        children: /*#__PURE__*/_jsx(Paragraph, {
          type: "medium",
          "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem_Paragraph",
          children: /*#__PURE__*/_jsx(ExternalLink, {
            url: "tel:".concat(phoneNumber),
            rel: "",
            "data-id": "retailer-utility-box-v2_index_StoreStatus_Paragraph_ExternalLink",
            children: phoneNumber
          })
        })
      }), emailAddress && /*#__PURE__*/_jsx(UtilityBoxItem, {
        icon: "email",
        role: "heading",
        "aria-label": "Email Address",
        "aria-level": "4",
        "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem",
        children: /*#__PURE__*/_jsx(Paragraph, {
          type: "medium",
          "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem_Paragraph",
          children: /*#__PURE__*/_jsx(ExternalLink, {
            url: "mailto:".concat(emailAddress),
            "data-id": "retailer-utility-box-v2_index_StoreStatus_Paragraph_ExternalLink",
            children: "Email us"
          })
        })
      }), hasWebsite && /*#__PURE__*/_jsx(UtilityBoxItem, {
        icon: "website",
        role: "heading",
        "aria-label": "Website",
        "aria-level": "4",
        "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem",
        children: /*#__PURE__*/_jsx(Paragraph, {
          type: "medium",
          "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem_Paragraph",
          children: /*#__PURE__*/_jsx(WebsiteLink, {
            websiteAddress: websiteAddress || undefined,
            link: link || undefined,
            linkText: linkText || undefined,
            "data-id": "retailer-utility-box-v2_index_StoreStatus_Paragraph_WebsiteLink"
          })
        })
      }), /*#__PURE__*/_jsx(StoreLocation, {
        status: status || undefined,
        location: location || undefined,
        nearestLocation: nearestLocation || undefined,
        locationLink: locationLink || undefined,
        openAt: openAt,
        "data-id": "retailer-utility-box-v2_index_StoreStatus_div_StoreLocation"
      }), parkingLocation && /*#__PURE__*/_jsx(UtilityBoxItem, {
        icon: "parking",
        role: "heading",
        "aria-label": "Parking",
        "aria-level": "4",
        "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem",
        children: /*#__PURE__*/_jsx(Paragraph, {
          type: "medium",
          "data-id": "retailer-utility-box-v2_index_StoreStatus_UtilityBoxItem_Paragraph",
          children: parkingLocation
        })
      })]
    }), Boolean(storeImage) && /*#__PURE__*/_jsx(Image, {
      className: style.storeImage,
      imageUrl: storeImage,
      ratio: "standard",
      alt: "Storefront",
      "data-id": "retailer-utility-box-v2_index_StoreStatus_Image"
    })]
  });
};
export default RetailerUtilityBox;